import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FactSheetStatusState {
  status: string | null;
}

const initialState: FactSheetStatusState = {
  status: null,
};

const factSheetStatusSlice = createSlice({
  name: 'factSheetStatus',
  initialState,
  reducers: {
    setFactSheetStatus(state, action: PayloadAction<string | null>) {
      state.status = action.payload;
    },
    resetFactSheetStatus(state) {
      state.status = null;
    },
  },
});

export const { setFactSheetStatus, resetFactSheetStatus } = factSheetStatusSlice.actions;
export default factSheetStatusSlice.reducer;
